export default __webpack_public_path__ + "static/media/package2.30ac00f6.jpg";